const iconButton = {
    color: 'primary.main',
    mr: 1,
};
const button = {
    padding: '0',
    '&:hover': {
        //you want this to be the same as the backgroundColor above
        backgroundColor: 'transparent',
    },
};
export default {
    iconButton,
    button,
};
